import React from 'react';
import {connect} from 'react-redux';
import * as Constants from "../../Common/constants";
import { ReportFeedWidget } from '../ReportFeedWidget/ReportFeedWidget';
import { LastReportWidget } from '../LastReportWidget/LastReportWidget';
import { LeaderboardWidget } from '../LeaderboardWidget/LeaderboardWidget';
//import React, { Component } from 'react';
import { render } from 'react-dom';
import Modal from 'react-modal';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileAlt,
    faAddressCard,
    faUsers,
    faSquare,
    faCheckSquare
  } from '@fortawesome/free-solid-svg-icons'


class Help extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPaneTermsOpen: false,
            isPaneAboutOpen: false,
            isPaneContactOpen: false
        };
        
    }

    componentDidMount() {
        Modal.setAppElement(this.el);
    }
openPane(){
    this.setState({ 
        
        isPaneAboutOpen: !this.state.isPaneAboutOpen });
}
    render() {
        let closeImg = Constants.IMAGE_SERVER + "/images/close.png";

        return <div ref={ref => this.el = ref}>
            <p onClick={ () => this.setState({ isPaneAboutOpen: true }) }>
            <FontAwesomeIcon icon={faUsers} /> About us
                </p>
                <p onClick={ () => this.setState({ isPaneTermsOpen: true }) }>
                <FontAwesomeIcon icon={faFileAlt}/> Terms Of Services
                </p>
                <p onClick={ () => this.setState({ isPaneContactOpen: true }) }>
                <FontAwesomeIcon icon={faAddressCard}/>  Contact
                </p>
            <SlidingPane
                closeIcon={<img style={{height:'20px', width:'20px', cursor:'pointer'}}src={closeImg}></img>}
                isOpen={ this.state.isPaneTermsOpen }
                title={<div>Terms Of Service <FontAwesomeIcon icon={faFileAlt}/></div>}
                from='bottom'
                width='100%'
                onRequestClose={ () => this.setState({isPaneTermsOpen: false }) }>
                <div>
                The following terms and conditions explain how users can make lawful use of
GOLFSNAPSHOT.com. We also provide more information on what we do on the ”About
us”.<br/><br/>
GOLFSNAPSHOT.com is a real-time score platform based on crowed sourced data
operated by GSS AB. We are an online media company service that aims to guide to golf
fans to the best available services. We earn revenue from advertising and affiliate
marketing via generating leads for our carefully-selected and respected business
partners.<br/><br/>
Please read the following information carefully. By accessing our site, you confirm that
you agree with the terms of use. Please do not use the site if you disagree with the terms
of use. Please refer to our Privacy Policy to find details on how we process any personal
data we collect from you and also find out how we use cookie files on our website.<br/><br/>
Website Content<br/><br/>
The content we provide on our site is for informative and general information only and
access to our website is provided free of charge. The content should never be used for
illegal activities.<br/><br/>
We endeavour to provide accurate content that refers to real-time information based on
crowdsourced collection for private use. However, the content is provided for information
purposes only and should be accepted by our users at their own risk. Third parties, may
change information at any time and therefore affect the content on
GOLFSNAPSHOT.com.<br/><br/>
We regularly update our website with new design, content and features, however, we
cannot guarantee it is free from errors. The provided information might be out of date at
any time, and we are under no legal obligation to update it.
Limitation of our liability<br/><br/>
GOLFSNAPSHOT.com will not be liable to any user for any loss or damage arising from
the use of our website and will not be responsible for any damages arising from:<br/><br/>
 The inability to use our site<br/>
 Use of or reliance on any content displayed on our site<br/>
 Loss of profits, sales, business, or revenue<br/>
 Loss of business opportunity, goodwill or reputation<br/><br/>
Intellectual property rights<br/><br/>
GOLFSNAPSHOT.com is the owner or licensee of intellectual property rights on our
website and all material published here. The content is protected by copyright laws and
treaties from the jurisdictions you are accessing this website from. You must not use any
part of the content on our website for commercial gain. We only permit access to our
website for private use. You agree to never use our website for commercial or business
purposes and offer no liability for any loss of profit or loss of business.<br/><br/>

We reserve the right to reject content removal requests unless the content could be
considered as unethical, false, discriminatory, in breach of person’s privacy or a violation
of any international law.<br/><br/>
Viruses<br/><br/>
We cannot guarantee that our website is secure or free from viruses. Users are
responsible for the protection of their own devices from viruses and malware.
We will not be liable for any loss or damage caused by a virus, distributed denial-of-
service attack, or other technologically harmful material that may infect your computer
equipment, computer programs, data or other proprietary material due to your use of our
site or to your downloading of any content on it, or on any website linked to it.
We will not accept anyone attempting to misuse our website and knowingly implement
malware or attack the website. The relevant law enforcement authorities will be informed
and your right to use our site will cease immediately.<br/><br/>
External links and sources<br/><br/>
Where our site contains external links to other domains and resources provided by third
parties, the links are provided for information purposes only. The majority of links direct
to our business partners providing sport related or iGaming services.
We have no control over the contents featured on those websites and assume no
responsibility for the content of websites linked on our site. We will not be liable for any
loss or damage that may arise from your use of them.<br/><br/>
GOLFSNAPSHOT.com reserves the right to advertise content that relates to gambling
activities, encouraging users to safe and secure entertainment. We promote responsible
gambling activities that serve to enhance users’ sports viewing experience, not to replace
the excitement of watching live sports events.<br/><br/>
As we feature various gambling operators, we take social responsibility to guide our
users to the fully secure and legal sources of online gaming. However, we are not liable
for any loss or damages that users might experience due to their gambling activities.
Users are permitted to link to our website, provided this is done in a fair and legal way,
that does not take advantage or damage our reputation.<br/><br/>
You must not establish a link to our site in any website that is not owned by you or
unlawfully associates this website to you without prior approval. We reserve the right to
withdraw linking permission without notice.<br/><br/>
We may revise our terms of use at any time by amending this page. Please check this
page regularly for any update to this policy. To contact us, please visit our contact page.
Last updated: August 16 2019</div>
            </SlidingPane>
            <SlidingPane
                closeIcon={<img style={{height:'20px', width:'20px',cursor:'pointer'}}src={closeImg}></img>}
                isOpen={ this.state.isPaneAboutOpen }
                title={<div>About Us <FontAwesomeIcon icon={faUsers}/></div>}
                from='bottom'
                width='100%'
                onRequestClose={ () => this.setState({isPaneAboutOpen: false }) }>
                <div>
Welcome to Golfsnapshot.com!<br></br>
We are a team of enthusiastic golfers, developers and digital marketing experts that all
share a common passion for watching golf. The idea of our platform emerged from our
shared interest in watching live golf and the lack of real-time leaderboard, shot-by-shot.
As time passed, we felt that there was a growing gap within the market for a product that
could improve and enhance the customer experience to follow golf tournaments by
getting an overview and quick reporting of the leaderboard.
By offering the golfing audience to follow their favorite players and at the same time see
how things are going for the challengers, the total excitement and experience can be
improved many times.<br></br><br></br>
SPOT ON! Friendly eyes on golf
<br></br><br></br>
The platform is built around crowdsourced collection and all data is collected and
reported by individuals for personal use. The unique scoring system selects and
evaluates information lightning fast to deliver secure and credible leaderboard data from
a variety of sources.
<br></br><br></br>
Crowdsourced data provided by individuals through the app is evaluated and judged
based on past relevance and precision. The scoring system means that the quality is
improved and ensured as well.
Become a reporter – download the golfsnapshot app (beta version) and become a
reporter - eye on course!
<br></br><br></br>
Our team of euthanasic reporters works hard to deliver real-time data to ensure fans of
various kinds are always up-to-date with the events of their favourite player, shots and all
the latest, must-watch tournaments! The platform is available on both in desktop and
mobile versions which can be downloaded via Google Play and AppStore.
The website features go beyond – the platform offers high-quality content that improves
fans’ viewing experience, with real-time detailed information about every shot and
movements. Think of it as an extensive leaderboard!<br></br><br></br>
Going further - We will even provide you with a fully customisable widget which could
easily be embedded on any website – letting a user adjust players, colours and sizes of
the widget accordingly to the needs of their website.<br></br><br></br>
Golfsnapshot is owned by GSS Networks AB, a leading content marketing and a
crowdsourced system developer. The company follows a clear framework for responsible
practices and guides both sports and gaming enthusiasts to the best possible services
available on the market.</div>
            </SlidingPane>
            <SlidingPane
                closeIcon={<img style={{height:'20px', width:'20px',cursor:'pointer'}}src={closeImg}></img>}
                isOpen={ this.state.isPaneContactOpen }
                title={<div>Contact <FontAwesomeIcon icon={faAddressCard}/></div>}
                from='bottom'
                width='100%'
                onRequestClose={ () => this.setState({isPaneContactOpen: false }) }>
                <div> </div>
            </SlidingPane>
        </div>;
    }
}

//render(<Help />, document.getElementById('help'));
 

const mapStateToProps = state => ({
  
    
    
 });
 
 /**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
 const mapActionsToProps = {
   
 };
 export default connect(mapStateToProps, mapActionsToProps)(Help);





















































/*class Help extends React.Component {
    constructor(props) {

        super(props);

        this.state = { }
    }

    componentWillMount() {

    }

    componentDidMount() {
      console.log("didmount!");
    }

    componentWillReceiveProps(nextProps) {
       
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }
 

    render() {
        
        console.info('Help - render called.', this.props);
        return (<div className="headerContainer">
            HELP PAGE!!!!!!!!!!!!!!!!!!!!!!!!!
        </div>);
        
    }
}

const mapStateToProps = state => ({
    lastitem: state.leaderboard.last
    
    
 });
 */
 /**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
 /*const mapActionsToProps = {
   
 };
 export default connect(mapStateToProps, mapActionsToProps)(Help);
*/
/*<div className="hamburgerMenu" onClick={() => this.setState({ change: true })}
                onAnimationEnd={() => this.setState({ change: false })}
                className={change ? 'change' : ''}>></div>*/


// WEBPACK FOOTER //
// ./src/Components/Footernav/Help.js